import classNames from "classnames";

import { DComponent } from "../../../../../../components/DComponent";
import { APPOTA_BANK_LIST, APPOTA_CARD_LIST, PAYMENT_ID, PAYMENT_METHOD, PAYMENT_PROVIDER } from "../../../../../../utils/payment";
import { defer } from "../../../../../../utils/script";

export default class CardItem extends DComponent {
  constructor({
    parent,
    id,
    option,
    type = CardItem.CARD_TYPE.CHILDREN,
    hasChildren,
    isPrimary,
    paymentMethodCode,
    paymentMethod,
    paymentProvider,
    cardInfo = {},
    onDelete = () => { },
    onSetPrimary = () => { },
    onAddNew = () => { },
    isChoose,
    isActive = false,
    onClick = () => { },
    onNotice = () => { },
  } = {}) {
    let paymentItem = PAYMENT_METHOD.find(item => item.paymentMethod === paymentMethod && (!paymentProvider || item.paymentProvider === paymentProvider)) || {};
    let isCard = (paymentMethod === PAYMENT_ID.ATM && paymentProvider === PAYMENT_PROVIDER.APPOTA) || (paymentMethod === PAYMENT_ID.CARD && paymentProvider === PAYMENT_PROVIDER.APPOTA);
    let iconCard = paymentMethod === PAYMENT_ID.ATM ?
      APPOTA_BANK_LIST.find(item => item.bankCode === cardInfo.bankCode) :
      APPOTA_CARD_LIST.find(item => item.bankCode === cardInfo.bankCode);
    super(arguments[0], parent, id, {
      class: classNames("CardItem", type, {
        "hide": paymentItem.isHide,
        "hide-icon": !paymentItem.icon,
        "is-card": isCard,
        "no-placeholder": !paymentItem.placeholder,
        "is-primary": isPrimary,
        "has-children": hasChildren,
        "is-choose": isChoose,
        "is-active": isActive,
        "has-notice": paymentItem.note,
        "has-discount": paymentItem.discount,
        "not-description": !paymentItem.description,
      }, `m-${paymentMethod}`, `p-${paymentProvider}`),
      iconPayment: isCard && iconCard ? iconCard.icon : paymentItem.icon,
      titlePayment: isCard ? cardInfo.cardNumber : "",
      titlePaymentI18n: !isCard || type !== CardItem.CARD_TYPE.CHILDREN ? paymentItem.label : "",
      cardPlaceholder: hasChildren ? paymentItem.placeholder : "",
      discountValue: paymentItem.discount,
      dataToggle: paymentItem.isCollapse ? "collapse" : "",
      showCollapse: paymentItem.autoOpen ? " show" : "",
      expandedCollapse: paymentItem.autoOpen ? "true" : "false",
      description: paymentItem.description ? `[html]${paymentItem.description}` : "",
    }, true);
    this.option = option;
    this.type = type;
    this.paymentMethodCode = paymentMethodCode;
    this.paymentMethod = paymentMethod;
    this.paymentProvider = paymentProvider;
    this.onDelete = onDelete;
    this.onSetPrimary = onSetPrimary;
    this.onAddNew = onAddNew;
    this.onClick = onClick;
    this.onNotice = onNotice;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "CardItem");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    $(".btn.delete-card", this.element).on("click", () => {
      typeof this.onDelete == "function" && this.onDelete(this.paymentMethodCode);
    });

    $(this.element).on("click", (e) => {
      if ($(e.target).attr("id") !== "notice") {
        typeof this.onClick == "function" && this.onClick(this);
      } else {
        typeof this.onNotice == "function" && this.onNotice(this);
      }
    });

    $(".btn.set-primary", this.element).on("click", () => {
      typeof this.onSetPrimary == "function" && this.onSetPrimary(this);
    });

    $(".btn.add-new", this.element).on("click", () => {
      typeof this.onAddNew == "function" && this.onAddNew(this.paymentMethod);
    });
  }

  setActive(isActive) {
    defer(() => this.element, () => {
      if (isActive) {
        $(this.element).addClass("is-active");
      } else {
        $(this.element).removeClass("is-active");
        if (this.element.attr("data-toggle") === "collapse") this.element.collapse("hide");
      }
    })
  }

  hide() {
    this.element.addClass("hide");
  }

  static CARD_TYPE = {
    CHILDREN: 'children',
    PARENT: 'parent',
  }
}